module.exports = "<div class=\"inmodal\">\n  <div class=\"color-line\"></div>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\">Session Expiration Warning</h4>\n    <small class=\"font-bold\">Your Session is about to Expire due to inactivity</small>\n  </div>\n  <div class=\"modal-body\">\n    <p>Your Session will Expire in {{countdown}} seconds</p>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"extendSession()\">Continue Session</button>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/common/modals/sessionExpirationModal/sessionExpirationModal.html
// module id = 1491
// module chunks = 0